"use strict";
/**
 * Error contract of the approved Data & API Design Baseline v1.3.
 *
 * Trace:
 * - Data & API v1.2 §18 «Error Contract» — content type, shape and first-slice
 *   stable codes;
 * - Data & API v1.2 §30.6 — additive stable Problem codes of TASK-ADM-002;
 * - Data & API v1.2 §31.6 — additive stable Problem codes of TASK-CIR-001;
 * - OpenAPI Delta Specification 1.3.0 — additive configuration Problem codes;
 * - canonical executable OpenAPI 1.3.0 (`openapi/openapi.yaml`) —
 *   `components.schemas.Problem`, `ValidationErrorDto`, `StaleAggregateDto`.
 *
 * Nothing here is designed: members, optionality and codes are transferred as
 * approved. New codes or members require change control.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TECHNICAL_PROBLEM_CODES = exports.STABLE_PROBLEM_CODES = exports.PROBLEM_TYPE_NAMESPACE = exports.PROBLEM_CONTENT_TYPE = void 0;
exports.problemTypeUrn = problemTypeUrn;
exports.PROBLEM_CONTENT_TYPE = 'application/problem+json';
/** Namespace of the `type` member, taken from the baseline example. */
exports.PROBLEM_TYPE_NAMESPACE = 'urn:vehicle-inspection:error';
/**
 * Stable codes of Data & API v1.2 §18 plus §30.6 and §31.6, extended by
 * OpenAPI Delta Specification 1.3.0, in the order of the approved documents.
 *
 * The baseline defines no code for an unexpected server failure, so none is
 * declared here: the technical exception boundary answers 5xx without a
 * machine-readable body until change control extends the catalogue.
 */
exports.STABLE_PROBLEM_CODES = [
    'MALFORMED_REQUEST',
    'VALIDATION_ERROR',
    'UNAUTHENTICATED',
    'AUTH_SESSION_REVOKED',
    'REFRESH_TOKEN_INVALID',
    'REFRESH_TOKEN_REUSED',
    'FORBIDDEN',
    'CAPABILITY_INVALID',
    'CAPABILITY_EXPIRED',
    'CAPABILITY_REVOKED',
    'CAPABILITY_CLOSED',
    'RESOURCE_NOT_FOUND',
    'STALE_VERSION',
    'IDEMPOTENCY_KEY_CONFLICT',
    'IDEMPOTENCY_IN_PROGRESS',
    'INVALID_STATE_TRANSITION',
    'OPEN_INTEGRATION_EXCEPTION',
    'OPEN_SYNC_CONFLICT',
    'SYNC_CONFLICT',
    'INCOMPLETE_CHECKLIST',
    'MISSING_REQUIRED_ASSESSMENT',
    'FAIL_DETAILS_REQUIRED',
    'NOT_APPLICABLE_JUSTIFICATION_REQUIRED',
    'NO_SHOW_GRACE_PERIOD_NOT_ELAPSED',
    'SIGNING_NOT_AUTHORIZED',
    'FACSIMILE_NOT_AVAILABLE',
    'FACSIMILE_NOT_OWNED',
    'RESULT_VERSION_MISMATCH',
    'DOCUMENT_GENERATION_STATE_INVALID',
    'EMAIL_DELIVERY_STATE_INVALID',
    'INTEGRATION_UNAVAILABLE',
    'INTEGRATION_THROTTLED',
    'IMPORT_PUBLISH_BLOCKED',
    'IMPORT_MAPPING_INVALID',
    'PASSWORD_CHANGE_REQUIRED',
    'CONFIGURATION_INCOMPLETE',
    'QUALIFICATION_MISSING',
    'INVALID_ACTIVATION_TARGET',
    'PROFILE_OUT_OF_SCOPE',
    'IDENTITY_REVIEW_REQUIRED',
    'IDENTITY_MAPPING_CONFLICT',
    'MASTER_UPDATE_PROPOSAL_STALE',
    'EQUIPMENT_TYPE_NOT_READY',
    'PACKAGE_CONFIGURATION_INVALID',
    'DOCUMENT_CONFIGURATION_CONFLICT',
    'CONFIGURATION_REFRESH_REQUIRED',
    'CONFIGURATION_REBASE_CONFLICT',
    'CONFIGURATION_REVALIDATION_REQUIRED',
    'PREPARED_PLAN_STALE',
    'PRELOAD_CONFIGURATION_STALE',
    'CONFIGURATION_DELTA_INCOMPLETE',
    'CONFIGURATION_DELTA_UNSUPPORTED',
    // TASK-NB-B Gate A additive codes
    'SLOT_UNAVAILABLE',
    // TASK-NB-C Package C additive codes
    'HOLD_EXPIRED',
    'BOOKING_VERSION_CONFLICT',
    'CASE_ALREADY_STARTED',
    'CASE_SUPERSEDED',
];
/**
 * Subset of the catalogue that the transport layer can produce on its own,
 * before any domain behaviour exists. Every value is a stable code.
 */
exports.TECHNICAL_PROBLEM_CODES = [
    'MALFORMED_REQUEST',
    'VALIDATION_ERROR',
    'UNAUTHENTICATED',
    'FORBIDDEN',
    'RESOURCE_NOT_FOUND',
];
/** Builds the `type` URN from a stable code, e.g. `STALE_VERSION` → `…:stale-version`. */
function problemTypeUrn(code) {
    return `${exports.PROBLEM_TYPE_NAMESPACE}:${code.toLowerCase().replaceAll('_', '-')}`;
}
//# sourceMappingURL=problem.js.map